import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=77191540"
import script from "./AdminEdit.vue?vue&type=script&lang=js"
export * from "./AdminEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports